import React from "react"
import PropTypes from "prop-types"

import { InvestmentShape, CustomerShape } from "@shapes"
import { INVESTMENT_PROFILE_TYPE_ENTITY } from "@components/Domain/Constants"

import BusinessCustomerUpgradeButton from "./BusinessCustomerUpgradeButton"
import PersonalCustomerUpgradeButton from "./PersonalCustomerUpgradeButton"


const CustomerUpgradeButton = ({ title, customer, investment, onSuccess }) => {
  const { profileType } = investment

  const isBusiness = profileType === INVESTMENT_PROFILE_TYPE_ENTITY

  if (isBusiness) {
    return (
      <BusinessCustomerUpgradeButton
        title={title}
        customer={customer}
        onSuccess={onSuccess}
        investment={investment}
      />
    )
  }

  return (
    <PersonalCustomerUpgradeButton
      title={title}
      customer={customer}
      onSuccess={onSuccess}
      investment={investment}
    />
  )
}

CustomerUpgradeButton.propTypes = {
  title: PropTypes.oneOfType([ PropTypes.string, PropTypes.shape() ]).isRequired,
  customer: CustomerShape.isRequired,
  onSuccess: PropTypes.func.isRequired,
  investment: InvestmentShape.isRequired,
}

export default CustomerUpgradeButton
